import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import { blogPosts } from './BlogData';
import BlogHeader from './BlogHeader';
import './Blog.css';
import { Link } from 'react-router-dom';


const BlogPostLayout = () => {
  const { slug } = useParams();
  const post = blogPosts.find((p) => p.slug === slug);
  const [markdown, setMarkdown] = useState('');

  useEffect(() => {
    if (post) {
      fetch(post.url)
        .then((res) => res.text())
        .then(setMarkdown)
        .catch((err) => setMarkdown(`Error loading post: ${err.message}`));
    }
  }, [post]);

  if (!post) return <p>Post not found</p>;

  return (
    <div>
      <BlogHeader />
      <div className="blog-container blog-post-content">
        <h1>{post.title}</h1>
        <p style={{ color: '#666' }}>{post.date}</p>
        <ReactMarkdown>{markdown}</ReactMarkdown>
      </div>
    </div>
  );
};

export default BlogPostLayout;
